import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';
import { Context } from '../Components/Context';

const Completed = () => {
    const { applicants, selectedPlan, isSubmitted } = useContext(Context);

    const navigate = useNavigate();

    // On load
    useEffect(() => {
        if (!applicants?.length || !applicants[0]?.sex) {
            navigate('/');
        }
        else if (!selectedPlan?.id) {
            navigate('/PlanSelect');
        }
        else if (!isSubmitted) {
            navigate('/Application');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <section className='completed mt-5'>
            <Container className='d-grid gap-3 mt-3'>
                <Row><Col>
                    <h1 className="display-3">Success</h1>
                </Col></Row>
                <Row><Col>
                    <h5 className="mb-4">Thank you for submitting your application.</h5>
                    <p>This application has been sent to our enrollment team for processing.</p>
                    <p>Details provided in this application will no longer be accessible to you once the submission process is finalized.</p>
                    <p>Please allow 3-5 business days for your application to be processed.</p>
                    <p>Incomplete applications will not be accepted.</p>
                    <p>If you have any questions, call us at 1.855.443.4735 (TTY/TDD relay: 1.800.955.8771) from 8 a.m. to 6 p.m. Monday through Friday.</p>
                    <p>Thank you for choosing Health First Health Plans. Be Well.</p>
                    <p className="mt-5"><a className="btn btn-primary btn-lg" role="button" href="/">Start A New Enrollment</a></p>
                </Col></Row>
            </Container>
        </section>
    )
}

export default Completed;
